import {
  Image,
  Modal,
  ScrollView,
  StyleSheet,
  Switch,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { COLORS, FONTS } from '../../constants';
import { ECardMemberProps } from './ECardMember.types';
import { getHeight, getWidth, IS_IOS, IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { close_icon, logo } from '../../assets/base64';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { AuthApi } from '../../services/api/auth.api';
import { Loading } from '../Loading';
import dayjs from 'dayjs';
import { setIsShowStart } from '../../services/redux/reducers/SwitchECardSlice';
import { setHeaderConfigAxios } from '../../services/api/axios';

const ECardMember: FC<ECardMemberProps> = ({ openModal, setOpenModal }) => {
  const { isShowStart } = useSelector(
    (redux: RootState) => redux.switchECardSlice
  );
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [qrImage, setQrImage] = useState<string>('');
  const [expiration, setExpiration] = useState<string>('');
  const { info, token } = useSelector((redux: RootState) => redux.authReducer);
  const width = getWidth();
  const height = getHeight();

  function getDayOfWeekFromTimestamp(timestamp: string) {
    // Extract year, month, day, hour, minute, and second from the timestamp
    const year = parseInt(timestamp.substring(0, 4), 10);
    const month = parseInt(timestamp.substring(4, 6), 10) - 1; // Months are 0-based
    const day = parseInt(timestamp.substring(6, 8), 10);
    const hour = parseInt(timestamp.substring(8, 10), 10);
    const minute = parseInt(timestamp.substring(10, 12), 10);
    const second = parseInt(timestamp.substring(12, 14), 10);

    // Create a Date object using the extracted components
    const date = new Date(year, month, day, hour, minute, second);

    return date;
  }

  const getQR = useCallback(async () => {
    try {
      setIsLoading(true);
      setHeaderConfigAxios(token);
      const res = await AuthApi.getECardQRCode();

      if (res.data.image_url != null) {
        setQrImage(res.data.image_url);
      } else if (res.data.image != null) {
        setQrImage(addBase64Prefix(res.data.image));
      }

      setExpiration(res.data.card_expired);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    getQR();
  }, [getQR]);

  return (
    <Modal visible={openModal} animationType="fade">
      <View style={[styles.headerModalWrapper, IS_IOS && { paddingTop: 60 }]}>
        <TouchableOpacity
          onPress={() => {
            if (setOpenModal) {
              setOpenModal(false);
            }
          }}
        >
          <Image
            source={
              IS_WEB
                ? addBase64Prefix(close_icon)
                : require('../../assets/close-icon.png')
            }
            style={{
              width: 20,
              height: 20,
              tintColor: COLORS.WHITE,
            }}
          />
        </TouchableOpacity>
      </View>
      <ScrollView
        style={{
          //minHeight: height,
          backgroundColor: COLORS.GREEN,
          position: 'relative',
        }}
      >
        <View style={styles.boxHeaderWrapper}>
          <Image
            source={
              IS_WEB ? addBase64Prefix(logo) : require('../../assets/logo.png')
            }
            style={styles.logoImage}
          />
          <Text style={styles.headerText}>KOWLOON CRICKET CLUB</Text>
        </View>
        <View style={styles.avatarWrapper}>
          <View style={styles.avatarLine}></View>
          <Image
            source={
              info?.avatar
                ? { uri: info?.avatar }
                : require('../../assets/avatar.png')
            }
            style={styles.avatar}
          />
          <View style={styles.avatarLine}></View>
        </View>
        <View style={styles.contentWrapper}>
          <Text style={styles.memberName}>
            {info?.display_name && info.display_name.length > 0
              ? info.display_name
              : info?.user_login}
          </Text>

          {isLoading ? (
            <Loading activityIndicatorColor="white" />
          ) : (
            <View
              style={{
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              {qrImage && qrImage.length > 0 && (
                <View>
                  <View
                    style={{
                      padding: 0,
                      backgroundColor: COLORS.WHITE,
                      marginBottom: 30,
                    }}
                  >
                    <Image
                      style={{
                        width: 300,
                        height: 300,
                      }}
                      source={{ uri: qrImage }}
                    />
                  </View>
                </View>
              )}

              <View>
                <View
                  style={{
                    flexDirection: 'column',
                  }}
                >
                  <View style={[styles.infoGroup, { width: width - 30 }]}>
                    <Text style={styles.infoTextLeft}>Member Number</Text>
                    <Text style={styles.infoTextRight}>
                      {info?.mbnum ? info?.mbnum : ''}
                    </Text>
                  </View>
                  <View style={[styles.infoGroup, { width: width - 30 }]}>
                    <Text style={styles.infoTextLeft}>Membership Type</Text>
                    <Text style={styles.infoTextRight}>
                      {info?.member_type ? info?.member_type : ''}
                    </Text>
                  </View>
                  <View style={[styles.infoGroup, { width: width - 30 }]}>
                    <Text style={styles.infoTextLeft}>Expiration</Text>
                    <Text style={styles.infoTextRight}>
                      {expiration
                        ? dayjs(getDayOfWeekFromTimestamp(expiration)).format(
                            'MMMM DD, YYYY'
                          )
                        : ''}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          )}
        </View>
      </ScrollView>
      <View
        style={{
          width: '100%',
          position: 'absolute',
          top: height,
          right: 5,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Text
            style={{
              color: COLORS.WHITE,
              fontFamily: FONTS.IowanOldStyleBTRoman,
              marginRight: 5,
              fontSize: 15,
            }}
          >
            Show E-Card On App Start
          </Text>
          <Switch
            trackColor={{
              false: COLORS.WHITE,
              true: COLORS.WHITE,
            }}
            ios_backgroundColor={COLORS.LIGHT_GREY}
            style={{ transform: [{ scaleX: 0.7 }, { scaleY: 0.7 }] }}
            thumbColor={isShowStart ? COLORS.LIGHT_GREEN : COLORS.LIGHT_GREY}
            onValueChange={(value: boolean) => {
              dispatch(setIsShowStart(value));
            }}
            value={isShowStart}
          />
        </View>
      </View>
    </Modal>
  );
};

export default ECardMember;

const styles = StyleSheet.create({
  headerModalWrapper: {
    paddingVertical: 20,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    backgroundColor: COLORS.GREEN,
  },
  infoGroup: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: COLORS.WHITE,
    paddingHorizontal: 25,
    paddingVertical: 10,
    borderRadius: 5,
    marginBottom: 10,
  },
  infoTextLeft: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: COLORS.GREEN,
    fontSize: 17,
    width: '50%',
    textAlign: 'left',
  },
  infoTextRight: {
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: COLORS.GREEN,
    fontSize: 17,
    width: '50%',
    textAlign: 'right',
  },
  boxHeaderWrapper: {
    backgroundColor: COLORS.GREEN,
    paddingBottom: 20,
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoImage: {
    width: 85,
    height: 85,
    resizeMode: 'contain',
    marginBottom: 5,
    position: 'relative',
  },
  headerText: {
    color: COLORS.WHITE,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    fontSize: 18,
  },
  avatarWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.GREEN,
  },
  avatarLine: {
    flex: 1,
    height: 2,
    backgroundColor: COLORS.WHITE,
  },
  avatar: {
    borderRadius: 105,
    width: 105,
    height: 105,
    resizeMode: 'contain',
    borderWidth: 2,
    borderColor: COLORS.WHITE,
  },
  contentWrapper: {
    backgroundColor: COLORS.GREEN,
    flexDirection: 'column',
    alignItems: 'center',
    padding: 20,
    marginBottom: 50,
  },
  memberName: {
    color: COLORS.WHITE,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    textTransform: 'uppercase',
    fontSize: 20,
    marginBottom: 18,
  },
});
